import { render } from "./CollectionsHeader.vue?vue&type=template&id=7706cccc&scoped=true"
import script from "./CollectionsHeader.vue?vue&type=script&lang=js"
export * from "./CollectionsHeader.vue?vue&type=script&lang=js"

import "./CollectionsHeader.vue?vue&type=style&index=0&id=7706cccc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7706cccc"]])

export default __exports__